import { render } from "./Navbar.vue?vue&type=template&id=fee9f042&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=fee9f042&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fee9f042"

export default script